
import { 
  FileText, 
  Package, 
  ShieldAlert, 
  HeartPulse, 
  Truck, 
  Settings,
  Box,
  Gift,
  Laptop,
  Car,
  Home,
  Briefcase,
  Camera,
  Book,
  Music,
  Gamepad2,
  Shirt,
  Coffee,
  Pizza,
  Flower,
  Wrench,
  PaintBucket,
  Zap,
  Globe,
  Star,
  Heart,
  Shield,
  LucideIcon
} from "lucide-react";

// Map of icon names to Lucide components
export const iconMap: Record<string, LucideIcon> = {
  FileText,
  Package,
  ShieldAlert,
  HeartPulse,
  Truck,
  Settings,
  Box,
  Gift,
  Laptop,
  Car,
  Home,
  Briefcase,
  Camera,
  Book,
  Music,
  Gamepad2,
  Shirt,
  Coffee,
  Pizza,
  Flower,
  Wrench,
  PaintBucket,
  Zap,
  Globe,
  Star,
  Heart,
  Shield,
};

// Get icon component by name, fallback to Package if not found
export const getIconByName = (iconName: string): LucideIcon => {
  return iconMap[iconName] || Package;
};

// Get list of available icon names for admin interface
export const getAvailableIcons = (): string[] => {
  return Object.keys(iconMap).sort();
};
